import React, { memo } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label, Input } from "abs-ui-components";

import {
	INPUT_STEP_VALUE,
	preventScientificNotation,
	roundOff,
} from "../../../services/utilities";

const AuxEngineFormGroup = (props) => {
	const {
		control,
		formState: { errors },
		setValue,
		trigger,
		getValues,
	} = useFormContext();

	const handleBlur = async (field, value) => {
		const newValue = value && value.trim() !== "" ? roundOff(value) : "";
		setValue(field, newValue);
		await trigger(field);
		const auxEngineValues = getValues("auxEngineList");
		const sumOfAuxEngineList = Object.values(auxEngineValues).reduce(
			(acc, val) => {
				const numericValue = parseFloat(val);
				return !isNaN(numericValue) && val.trim() !== ""
					? acc + numericValue
					: acc;
			},
			0
		);
		props?.setSumofAuxEnginePowers(sumOfAuxEngineList);
	};

	const configuredMainEngineData =
		props.vesselData?.VesselEnginePowerDtls?.filter((item) => {
			return item.EngineType === "AE";
		});

	const transformedData = configuredMainEngineData?.reduce((result, item) => {
		const key = item.EngineName;
		const value = item.OutputPower;
		result[key] = value;
		return result;
	}, {});

	return (
		<div className="container-fluid p-0 m-0">
			<MDBRow>
				<MDBCol md="3" className="mt-3">
					<Label
						required
						bold
						name="AE1 Power (kW)"
						className="mb-1"
					/>
					<Controller
						name="auxEngineList.AE1"
						control={control}
						rules={
							props?.regulations?.trim() !== "EUMRV" &&
								props?.regulations?.trim() !== "UKMRV" &&
								props?.regulations?.trim() !== "DCS"
								? {
									required: "AE1 power is required",
									min: {
										value: Number.EPSILON,
										message:
											"Please enter a value greater than zero.",
									},
								}
								: {}
						}
						defaultValue={
							props?.vesselMstId
								? roundOff(transformedData?.AE1)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}

								id="aux_engine_ae1_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								required
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
					{errors.auxEngineList && errors.auxEngineList.AE1 && (
						<div className="error-msg">
							{errors.auxEngineList.AE1.message}
						</div>
					)}
				</MDBCol>

				<MDBCol md="3" className="mt-3">
					<Label bold name="AE2 Power (kW)" className="mb-1" />
					<Controller
						name="auxEngineList.AE2"
						control={control}
						defaultValue={
							props?.vesselMstId
								? transformedData?.AE2 === 0
									? ""
									: roundOff(transformedData?.AE2)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}

								id="aux_engine_ae2_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="3" className="mt-3">
					<Label bold name="AE3 Power (kW)" className="mb-1" />
					<Controller
						name="auxEngineList.AE3"
						control={control}
						defaultValue={
							props?.vesselMstId
								? transformedData?.AE3 === 0
									? ""
									: roundOff(transformedData?.AE3)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="aux_engine_ae3_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="3" className="mt-3">
					<Label bold name="AE4 Power (kW)" className="mb-1" />
					<Controller
						name="auxEngineList.AE4"
						control={control}
						defaultValue={
							props?.vesselMstId
								? transformedData?.AE4 === 0
									? ""
									: roundOff(transformedData?.AE4)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="aux_engine_ae4_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>
			</MDBRow>
			<MDBRow>
				<MDBCol md="3" className="mt-3">
					<Label bold name="AE5 Power (kW)" className="mb-1" />
					<Controller
						name="auxEngineList.AE5"
						control={control}
						defaultValue={
							props?.vesselMstId
								? transformedData?.AE5 === 0
									? ""
									: roundOff(transformedData?.AE5)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="aux_engine_ae5_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								maxLength={7}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="3" className="mt-3">
					<Label bold name="AE6 Power (kW)" className="mb-1" />
					<Controller
						name="auxEngineList.AE6"
						control={control}
						defaultValue={
							props?.vesselMstId
								? transformedData?.AE6 === 0
									? ""
									: roundOff(transformedData?.AE6)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="aux_engine_ae6_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="3" className="mt-3">
					<Label bold name="AE7 Power (kW)" className="mb-1" />
					<Controller
						name="auxEngineList.AE7"
						control={control}
						defaultValue={
							props?.vesselMstId
								? transformedData?.AE7 === 0
									? ""
									: roundOff(transformedData?.AE7)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="aux_engine_ae7_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="3" className="mt-3">
					<Label bold name="AE8 Power (kW)" className="mb-1" />
					<Controller
						name="auxEngineList.AE8"
						control={control}
						defaultValue={
							props?.vesselMstId
								? transformedData?.AE8 === 0
									? ""
									: roundOff(transformedData?.AE8)
								: ""
						}
						render={({ field }) => (
							<Input
								name={field.name}
								id="aux_engine_ae8_power"
								disabled={
									!props?.isEnrollVessel &&
									props?.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								type="number"
								min="1"
								step={INPUT_STEP_VALUE}
								className="input-height"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default memo(AuxEngineFormGroup);
